module.exports = __webpack_public_path__ + "media/effects-13.ad587a82.webm";